(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('ASTBMsoDialogController', MsoDialogController);

    MsoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Mso','AlertService'];

    function MsoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Mso,AlertService) {
        var vm = this;

        vm.mso = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.mso.id !== null) {
                Mso.update(vm.mso, onSaveSuccess, onSaveError);
            } else {
                Mso.save(vm.mso, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('nasracApp:msoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
